import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#031f30",
      d: "M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "6.75",
      cy: "12",
      r: "1.5",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "1.5",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "17.25",
      cy: "12",
      r: "1.5",
      fill: "#fff"
    }, null, -1)
  ]))]))
}
export default { render: render }